export default function removeTrailingEmptyNodes(html) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    let shouldBreakOuter = false;
    for (let i = tempDiv.children.length - 1; i >= 0; i--) {
        if (shouldBreakOuter) break;
        const child = tempDiv.children[i];
        if (child.nodeType === Node.ELEMENT_NODE && child.tagName === "P") {
            if (!child.textContent.trim()) {
                tempDiv.removeChild(child);
            } else {
                for (let j = child.childNodes.length - 1; j >= 0; j--) {
                    const innerChild = child.childNodes[j];
                    const isBr = innerChild.nodeType === Node.ELEMENT_NODE && innerChild.tagName === "BR";
                    const isEmptyText = innerChild.nodeType === Node.TEXT_NODE && !innerChild.textContent.trim();
                    if (isBr || isEmptyText) {
                        child.removeChild(innerChild);
                    } else if (innerChild.nodeType === Node.TEXT_NODE) {
                        const trimmedText = innerChild.textContent.trim();
                        if (trimmedText) {
                            innerChild.textContent = innerChild.textContent.replace(/\s+$/, "");
                            shouldBreakOuter = true;
                            break;
                        } else {
                            child.removeChild(innerChild);
                        }
                    }
                }
            }
        } else {
            break;
        }
    }
    return tempDiv.innerHTML;
}
